import React from 'react';

const SECTION_TIPS = {
  basicInformation:
    "Your dates and contact info help us build the right timeline and send your itinerary.",
  groupInfo:
    "Group size and ages help us suggest the right experiences and pacing for everyone.",
  parkTicketAccess:
    "Ticket type and Park Hopper help us match your access and plan park days correctly.",
  parkVisitPlans:
    "Choosing which parks and how many days helps us balance your visit and suggest the best order.",
  accommodation:
    "Your resort and transportation help us time your days and suggest nearby options.",
  attractionRideStrategy:
    "Pick your must-do rides. You can add Nice-to-have preferences anytime.",
  showFireworkStrategy:
    "Pick your must-see shows. You can add Nice-to-have preferences anytime.",
  diningPreferences:
    "Pick your must-try restaurants. You can add Nice-to-have preferences anytime.",
  timeEnergy:
    "Start times and break preferences help us pace your itinerary so it feels right.",
};

const DEFAULT_TIP =
  "The more we know, the more tailored your itinerary will be.";

const FastTrackTipBanner = ({ sectionId, onSwitchToFull }) => {
  const tip =
    (sectionId && SECTION_TIPS[sectionId]) ||
    DEFAULT_TIP;

  return (
    <div className="q2-panel-tip rounded-lg p-4">
      <p className="q2-panel-tip__text mb-3 text-sm leading-relaxed">
        <strong>Optional:</strong> {tip}
      </p>
      <button
        type="button"
        onClick={onSwitchToFull}
        className="q2-panel-tip__btn inline-flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1"
      >
        Add more preferences
      </button>
    </div>
  );
};

export default FastTrackTipBanner;
